import L from 'leaflet';
import { RouteStatus } from '@/pages/Business/pages/Monitoring/enums/RouteStatus';
import { useDriverGpsPosition } from '../hooks/useDriverGpsPosition';
import { useLiveDriverMarker } from '../hooks/useLiveDriverMarker';
import { shouldTrackRouteGps } from '../utils/shouldTrackRouteGps';
import { DriverGpsInfoPanel } from './DriverGpsInfoPanel';

export interface LiveDriverMapLayerProps {
  mapInstance: L.Map | null;
  mapReady: boolean;
  driverId: string | null | undefined;
  routeStatus: RouteStatus | undefined;
  driverName?: string;
}

export const LiveDriverMapLayer = ({
  mapInstance,
  mapReady,
  driverId,
  routeStatus,
  driverName,
}: LiveDriverMapLayerProps) => {
  const isTrackable = shouldTrackRouteGps(routeStatus, driverId);

  const { position, isLoading, error, isStale, hasSignal } =
    useDriverGpsPosition(driverId, { skip: !isTrackable });

  useLiveDriverMarker(isTrackable && mapReady ? mapInstance : null, position);

  if (!isTrackable) {
    return null;
  }

  return (
    <DriverGpsInfoPanel
      driverName={driverName}
      position={position}
      isLoading={isLoading}
      isStale={isStale}
      hasSignal={hasSignal}
      error={error}
    />
  );
};
